module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "user-login-5"
  }, [_c('div', {
    staticClass: "row bs-reset"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 login-container bs-reset mt-login-5-bsfix"
  }, [(!_vm.forgotPassword) ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("UNOapp Login")]), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "email",
      "autocomplete": "off",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_c('a', {
    staticClass: "forget-password",
    attrs: {
      "id": "forget-password"
    },
    on: {
      "click": function($event) {
        _vm.showForgotPassword()
      }
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])])]) : _vm._e(), _vm._v(" "), (_vm.forgotPassword) ? _c('div', {
    staticClass: "login-content"
  }, [_c('h3', {
    staticClass: "font-green"
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('p', [_vm._v(" Enter your e-mail address below to reset your password. ")]), _vm._v(" "), (!_vm.emailSent) ? _c('form', {
    staticClass: "forget-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForgotPassword($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger alert-email-error"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control placeholder-no-fix form-group",
    attrs: {
      "type": "email",
      "autocomplete": "off",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn green btn-outline",
    attrs: {
      "type": "button",
      "id": "back-btn"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success uppercase pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSent) ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("An email has been sent to you with a link to reset your password! Please make sure you check your spam folder.")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Login")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showMobileAppPopup,
      "effect": "fade"
    },
    on: {
      "update:show": function($event) {
        _vm.showMobileAppPopup = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header text-center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Hi!")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n\t\t\t\tWe recommend using our mobile app for " + _vm._s(_vm.deviceType) + ". The app can be downloaded from "), _c('a', {
    attrs: {
      "href": _vm.appStoreDetails.url
    }
  }, [_vm._v(_vm._s(_vm.appStoreDetails.type))]), _vm._v(".\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileAppPopup = false
      }
    }
  }, [_vm._v("Okay")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 bs-reset mt-login-5-bsfix"
  }, [_c('div', {
    staticClass: "login-bg"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("../assets/img/app/logo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d485b34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 439
// module chunks = 1